import { gql } from '@apollo/client'

export const UPDATE_ACTION_MUTATION = gql`
  mutation updateAction($id: ID!, $attributes: ActionInput!) {
    updateAction(id: $id, attributes: $attributes) {
      hint
      draft
      claimDate
      fileNumber
      closingResult
      closingTypeId
      closingTypeOther
      communicationViaCustomerPortal
      rightActualProcessingType
      rsvLegalArea {
        id
        title
      }
      rsvLegalAreaId
      settlementComments
      actualProcessingType {
        id
        title
        legalAdviceOnly
      }
      actualProcessingTypeId
      intendedProcessingType {
        id
        title
      }
      intendedProcessingTypeId
      contactPersonFirstname
      contactPersonLastname
      contactPersonEmail
      contactPersonPhoneNumber
      contactPersonMobileNumber
      contactPersonSalutation
      contactPersonRelationToPolicyholder
      policyholderFirstname
      policyholderLastname
      policyholderEmail
      policyholderPlace
      policyholderPostalCode
      policyholderPhoneNumber
      policyholderMobileNumber
      policyholderSalutation
      policyNumber
      claimNumber
      conflictPartnerCompany
      conflictPartnerSalutation
      conflictPartnerFirstname
      conflictPartnerLastname
      conflictPartnerEmail
      conflictPartnerPhoneNumber
      conflictPartnerPlace
      conflictPartnerStreet
      conflictPartnerHouseNumber
      conflictPartnerSalutation
      conflictPartnerMobileNumber
      needsCollisionDetection
      noCollisionByHuman
      completeReason
      conflictPartnerAgreesMediation
      conflictPartnerAgreesToCoverCosts
      contactSuccessful
      contactType
      costs
      costsCoveredByKp
      createdAt
      customerComments
      customerRating
      customerMessageType
      dataset
      date
      firstCall
      id
      informReason
      internalTransferReason
      note
      legalAdvice
      mailSentAt
      attorneyStatus
      noMailSentReason
      attorneyReason
      attorneyType
      policyholderAgreesMediation
      processing {
        agentId
        id
        m2Case {
          id
        }
        involvedUsers {
          id
          name
        }
      }
      processingId
      type
      updatedAt
      user {
        id
        name
        role
      }
      userId
      visibleForOtherProcessings
      visibleForPolicyholder
      uploads {
        id
        attachmentUrl
        attachmentFilename
        attachmentSignedId
      }
    }
  }
`
